<template>
  <div
    class="video-player-wrapper"
    @mouseover="handleMouseover"
    @mouseout="handleMouseout">
    <video id="video" ref="videoPlayer" :src="url" :preload="preload" :muted="muted" />
  </div>
</template>
<script>
import { GET_FILE_LINK } from '@/utils/api'
export default {
  name: 'file-video',

  props: {
    src: {
      type: String,
      required: true,
      default: ''
    },
    preload: {
      type: String,
      required: false,
      default: 'metadata' // none metadata auto
    },
    muted: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    this.player = null
    return {
      url: ''
    }
  },

  watch: {
    src () {
      this.getUrl()
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.init()
    })
  },

  created () {
    this.getUrl()
  },

  methods: {
    async getUrl () {
      const res = await GET_FILE_LINK(this.src)
      this.url = res.data
    },

    init () {
      if (this.$refs.videoPlayer) {
        this.player = this.$refs.videoPlayer
        return
      }
      setTimeout(() => {
        this.init()
      }, 100)
    },

    play () {
      this.playerOptions.sources[0].src = this.url
    },

    hideVideoPlayer() {
      this.playerOptions.sources[0].src = ''
    },

    handleMouseover () {
      this.player.play()
    },

    handleMouseout () {
      this.player.pause()
    }
  }
}
</script>
<style lang="scss" scoped>
.video-player-wrapper {
  width: 100%;
  height: 100%;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>